






































































































































































































import moment from 'moment';
import flatPicker from 'vue-flatpickr-component';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import 'flatpickr/dist/flatpickr.css';
import orderKindType from '@/store/types/orderKinds';
import { CustomLocale } from 'flatpickr/dist/types/locale';
import { http } from '@/util/HTTP';
import { mapActions, mapGetters } from 'vuex';
import Vue from 'vue';
moment.locale('es');

type nameValue = {
  name: string;
  value: string;
};

type FilterString = {
  branch_id: string;
  payment_method_eq: string;
  created_on?: string;
  authorization_number_eq: string;
  reference_number_eq: string;
  risk_eq: string;
  kind_eq: string;
  company_id: string;
  commerce_id: string;
  created_after?: string;
  created_before?: string;
  status_eq: string;
  subtotal_cents_gte?: number | string;
  subtotal_cents_lte?: number | string;
};
type Config = {
  allowInput: boolean;
  wrap: boolean; // set wrap to boolean, only when using 'input-group'
  altFormat: string;
  altInput: boolean;
  dateFormat: string;
  locale: CustomLocale;
};

export default Vue.extend({

  name: 'FilterPostMortem',
  components: {
    'flat-picker': flatPicker,
  },
  props: {
    query: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    transactionType: '',
    http: http,
    transactionDateFilter: '',
    dateType: '',
    dateSelect: '',
    yearMonth: '',
    range: '',
    searchLabel: '',
    users: [],
    device: '',
    amountType: '',
    amount1: 0,
    amount2: 0,
    discountType: '',
    discount1: 0,
    discount2: 0,
    filterString: {
      payment_method_eq: '',
      branch_id: '',
      created_on: '',
      authorization_number_eq: '',
      reference_number_eq: '',
      risk_eq: '',
      kind_eq: '',
      company_id: '',
      commerce_id: '',
      created_after: '',
      created_before: '',
      subtotal_cents_gte: 0,
      subtotal_cents_lte: 0,
    } as FilterString,
    config: {
      allowInput: true,
      wrap: true, // set wrap to true only when using 'input-group'
      altFormat: 'M j, Y',
      altInput: true,
      dateFormat: 'Y-m-d',
      locale: Spanish,
    } as Config,

    getTransactionType: [
      {
        name: 'Todas',
        value: 'Todas',
      },
      {
        name: 'P2B',
        value: 'P2B',
      }
    ] as nameValue[],

    paymentMethods: [
      {
        name: 'Tarjeta',
        id: 'credit_card',
      },
      {
        name: 'Balance',
        id: 'cash',
      },
      {
        name: 'Tarjeta y balance',
        id: 'both',
      }
    ],

    getStatusFilter: [
      {
        name: 'Todas',
        value: '',
      },
      {
        name: 'Pendiente',
        value: 'pending',
      },
      {
        name: 'Completadas',
        value: 'success',
      },
      {
        name: 'Con fallas',
        value: 'failure',
      },
      {
        name: 'Rechazadas',
        value: 'rejected',
      },
      {
        name: 'Canceladas',
        value: 'cancelled',
      },
      {
        name: 'Expiradas',
        value: 'expired',
      }
    ] as nameValue[],

    getTransactionDateFilter: [
      {
        name: 'Dia',
        value: 'day',
      },
      {
        name: 'Rango',
        value: 'between',
      }
    ] as nameValue[],

    amountFilter: [
      {
        name: 'Mayor o igual que',
        value: 'greaterThan',
      },
      {
        name: 'Menor o igual que',
        value: 'lessThan',
      },
      {
        name: 'Rango',
        value: 'between',
      }
    ] as nameValue[],

    getRiskFilter: [
      {
        name: 'Todas',
        value: '',
      },
      {
        name: 'Ninguno',
        value: 'none',
      },
      {
        name: 'Bajo',
        value: 'low',
      },
      {
        name: 'Medio',
        value: 'moderate',
      },
      {
        name: 'Alto',
        value: 'high',
      }
    ] as nameValue[],
  }),
  computed: {
    ...mapGetters({
      getOrderKindList: `orderKindModule/${orderKindType.getters.GET_ORDER_KINDS}`,
    }),
    syncedQuery: {
      get(): string {
        return this.query;
      },
      set(value: string): void {
        this.$emit('update:query', value);
      },
    },
  },
  async mounted(): Promise<void> {
    await this.orderKindList();
    this.loading = false;
  },
  methods: {
    ...mapActions({
      orderKindList: `orderKindModule/${orderKindType.actions.ORDER_KINDS}`,
    }),
    search(): void {
      let filters = '';
      Object.entries(this.filterString).forEach(([key, value]) => {
        value !== '' && (filters += `&${key}=${value}`);
      });
      this.syncedQuery = filters;
    },

    clear(): void {
      this.amountType = '';
      this.transactionDateFilter = '';
      this.amount1 = 0;
      this.amount2 = 0;
      this.range = '';
      this.filterString = {
        status_eq: '',
        payment_method_eq: '',
        branch_id: '',
        created_on: '',
        authorization_number_eq: '',
        reference_number_eq: '',
        risk_eq: '',
        kind_eq: '',
        company_id: '',
        commerce_id: '',
        created_after: '',
        created_before: '',
        subtotal_cents_gte: 0,
        subtotal_cents_lte: 0,
      };
      this.syncedQuery = '';
    },
  },
  watch: {
    range: {
      immediate: true,
      deep: true,
      handler(val: string): void {
        if (val) {
          const dates = val.split(' a ');
          if (dates.length === 2) {
            this.filterString.created_after = dates[0];
            this.filterString.created_before = dates[1];
          }
        }
      },
    },
    amountType: {
      immediate: true,
      deep: true,
      handler(val: string): void {
        if (val !== '') {
          this.amount1 = 0;
          this.amount2 = 0;
        } else {
          delete this.filterString.subtotal_cents_gte;
          delete this.filterString.subtotal_cents_lte;
        }
      },
    },
    amount1: {
      immediate: true,
      deep: true,
      handler(val: number): void {
        if (val.toString() !== '') {
          if (this.amountType === 'between') {
            this.filterString.subtotal_cents_gte = val * 100;
            this.filterString.subtotal_cents_lte = 0;
          } else if (this.amountType === 'greaterThan') {
            this.filterString.subtotal_cents_gte = val * 100;
            this.filterString.subtotal_cents_lte = '';
          } else if (this.amountType === 'lessThan') {
            this.filterString.subtotal_cents_gte = '';
            this.filterString.subtotal_cents_lte = val * 100;
          } else {
            delete this.filterString.subtotal_cents_lte;
            delete this.filterString.subtotal_cents_gte;
          }
        }
      },
    },
    amount2: {
      immediate: true,
      deep: true,
      handler(val: number): void {
        if (val.toString() !== '' && this.amountType === 'between') {
          this.filterString.subtotal_cents_lte = val * 100;
        }
      },
    },
    transactionDateFilter: {
      immediate: true,
      deep: true,
      handler(val: string): void {
        this.yearMonth = '';
        this.range = '';
        if (val === 'day') {
          this.searchLabel = 'Día';
        } else if (val === 'between') {
          this.searchLabel = 'Rango de fechas';
        } else {
          delete this.filterString.created_after;
          delete this.filterString.created_before;
          delete this.filterString.created_on;
        }
      },
    },
  },
});
